import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Col } from 'reactstrap';
import { Button, JustifyContents, Alignment, Icon, SearchInput, Variant } from 'tacho-ui';
import { UsersModel } from '../../../../core/domainModels/users/UsersModel';
import { TachoToolbar, TachoToolbarHorizontalLine } from '../../../components/TachoToolbar';

interface UsersToolbarProps {
    selectedUsers: Array<UsersModel>;
    openConfirmRemoveModal: () => void;
    openAddUserModal: () => void;
    openUpdateUserModal: () => void;
    onRefresh: () => void;
    onSearchQueryChanged: (newQuery: string) => void;
}
export const UsersToolbar = (props: UsersToolbarProps) => {
    const { formatMessage } = useIntl();
    const [typingTimeout, setTypingTimeout] = useState(0);
    const searchQueryTypingTimeoutMS = 500;
    function onSearchInputChanged(newValue: string): void {
        setTypingTimeout(Date.now() + searchQueryTypingTimeoutMS);
        const timeoutDelayMS = 10;
        setTimeout(() => {
            const now = Date.now();
            if (now > typingTimeout) {
                props.onSearchQueryChanged(newValue);
            }
        }, searchQueryTypingTimeoutMS + timeoutDelayMS);
    }
    return (
        <TachoToolbar>
            <Col className="d-flex flex-wrap gap-2">
                <Button
                    justify={JustifyContents.center}
                    align={Alignment.center}
                    gap={4}
                    text={formatMessage({ id: 'commonAdd' })}
                    icon={Icon.Add}
                    className="primary"
                    onClick={props.openAddUserModal}
                />
                <Button
                    justify={JustifyContents.center}
                    align={Alignment.center}
                    gap={4}
                    text={formatMessage({ id: 'commonEdit' })}
                    icon={Icon.Edit}
                    className="primary"
                    onClick={props.openUpdateUserModal}
                    disabled={props.selectedUsers.length !== 1}
                />
                <Button
                    justify={JustifyContents.center}
                    align={Alignment.center}
                    gap={4}
                    text={formatMessage({ id: 'commonDelete' })}
                    icon={Icon.Delete}
                    className="primary"
                    onClick={props.openConfirmRemoveModal}
                    disabled={props.selectedUsers.length !== 1}
                />

                <TachoToolbarHorizontalLine />

                <SearchInput
                    onChange={onSearchInputChanged}
                    width="auto"
                    height="auto"
                    variant={Variant.Toolbar}
                    placeholder={formatMessage({ id: 'commonSearch' })}
                    value={undefined}
                />

                <Button
                    justify={JustifyContents.center}
                    align={Alignment.center}
                    gap={4}
                    icon={Icon.Refresh}
                    className="primary"
                    onClick={props.onRefresh}
                />
            </Col>
        </TachoToolbar>
    );
};
